<template>
  <input v-if="!changed" @change="changeFun($event)">
  <i v-else></i>
</template>
<script>
export default {
  name: 'InputFile',
  data () {
    return {
      changed: false
    }
  },
  methods: {
    changeFun (e) {
      this.changed = true
      let files = []
      if (e && e.target && e.target.files) {
        files = e.target.files
      }
      this.$emit('change', files, e)
      this.$nextTick(() => {
        this.changed = false
      })
    }
  }
}
</script>
